module.exports = __webpack_public_path__ + "static/img/logo.b627573a.png";